module.exports = __webpack_public_path__ + "img/light-on-dent-red.aa6027b2.svg";